module.exports = __webpack_public_path__ + "static/media/29.e3cc07a4.jpg";